<template lang="pug">
AddOrEdit(type="stream")
</template>

<script>
import AddOrEdit from '@/partials/Products/AddOrEdit.vue';

export default {
  components: {
    AddOrEdit,
  },
};
</script>
